<template> 
  <n-dialog
    v-model="dialog"   
    class="text-center"
  >  
    <v-card>
      <v-card-title
        primary-title
        class="lighten-2"
      >
        <v-spacer />
        <h2>{{ $t('rules-play') }}</h2><v-spacer />
      </v-card-title>
      <v-card-text
        class="optimizeWidth"
        v-html="formattedContent(message)"
      />    

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn 
          color="var(--bg-secondary-color)"
          class="white--text"
          @click="submit"
        >
          {{ $t('button.i-got-it') }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </n-dialog> 
</template>
<script>
import { formattedContent } from '@/plugins/helper'

export default {
  props : {
    message : {
      type : String,
      default : ()=> ''
    }
  },
  data () {
    return {
      dialog: false,
    }
  },
  methods : { 
    formattedContent,
    submit (){  
      this.$ga.event('Submit', 'LottoRule', 'GamePage','')
      this.dialog=false 
    }, 
    open (){
      this.dialog = true
    },
  }
}
</script> 